import { capitalize } from '../../utils/strings'
import { Experiment } from '@grammarly/experimentation-js-sdk'
import type { StatsigTreatmentOrNull } from './experiments'

export const sanitizeExperimentGroupName = (groupName: string) => {
  if (groupName.endsWith('_1') || groupName.endsWith('_2')) {
    return groupName.substring(0, groupName.length - 2)
  }

  return groupName
}

export function createExperimentMethods(
  getAssignmentFn: (key: string) => StatsigTreatmentOrNull<Experiment>,
  peekAssignmentFn: (key: string) => StatsigTreatmentOrNull<Experiment>,
  clientConfig: Record<string, unknown>,
  serverConfig: Record<string, unknown>
): Record<string, () => StatsigTreatmentOrNull<Experiment>> {
  const methods: Record<string, () => StatsigTreatmentOrNull<Experiment>> = {}

  const configs = [clientConfig, serverConfig]
  for (const config of configs) {
    for (const key in config) {
      methods[`get${capitalize(key)}Assignment`] = () => getAssignmentFn(key)
    }
  }

  // Generate peek methods only for client experiments (server experiments are pre-assigned)
  for (const key in clientConfig) {
    methods[`peek${capitalize(key)}Assignment`] = () => peekAssignmentFn(key)
  }

  return methods
}
